"use client";
import NavBar from "@public-sites/unified-header/dist/src";
import { useRouter } from "next/navigation";
import React, { useEffect } from "react";

export interface SharedNavBarProps extends React.ComponentProps<typeof NavBar> {}

const Prefetch: React.FC<SharedNavBarProps> = props => {
	const router = useRouter();
	useEffect(() => {
		// Prefetch all relative URLs in the bottomItems list
		props.bottomItems?.forEach(({ href }) => {
			if (typeof href === "string" && href.startsWith("/")) {
				router.prefetch(href);
			}
		});
	}, [router, props.bottomItems]);

	return <></>;
};

export default Prefetch;
